import { BaseAdminOperations } from "../../BaseAdminOperations";
import { Observable, Observer } from "rxjs";
import { IOrganisation, OrganisationSurvey } from "../../../../model/ModelTypes";
import { DatabaseKey } from "../../../../repository/IDataStore";
import { flatMap, map } from "rxjs/operators";
import { isNullOrUndefined } from "util";
/**
 * Implements business logic for Operations available for Organisation Surveys
 */
export class OrganisationSurveysOperations extends BaseAdminOperations {
    errorCallback: Function;
    // tslint:disable-next-line:no-empty
    onInitializationComplete() {
        
    }
    observeSurveys = () => this.observeOrganisationChanges()
    .pipe(
        map(
            organisation => organisation.organisation_surveys
        )    
    )

    observeAvailableRoles = () => this.observeOrganisationChanges()
    .pipe(
        map(organisation => organisation.roles)
    )

    deleteSurvey(surveyId: string): Observable<IOrganisation> {
        return Observable.create(
            async (observer: Observer<IOrganisation>) => {
                let response = await this.adminApi.getAuthenticatedHttpClient()
                .getInstance().delete(`/api/organisationSurveys/${this.organisationCode}/${surveyId}`, {});
                let deletedSurveyId: string = response.data.toString();
                if (
                    response.status === 200 && 
                    !isNullOrUndefined(deletedSurveyId) &&
                    deletedSurveyId  === surveyId
                ) {
                  this.removeDeletedSurvey(deletedSurveyId)
                    .subscribe(
                        result => {
                            observer.next(this.organisation);
                            return observer.complete();
                        },
                        error => {
                            this.reportError(error);
                            observer.error(error);
                            return observer.complete();
                        } 
                    );
                } else {
                    observer.error(new Error("Failed to Delete Notification"));
                    return observer.complete();
                }        
            }
        );
    }
  
    observeOrganisationChanges(): Observable<IOrganisation> {
        return this.dataStore.getDocuments<Observable<IOrganisation>>(DatabaseKey.organisation)
        .pipe(
            flatMap(item => item),
            map( item => {
                this.organisation = item;
                return item;
            })
        );
    }
    modifyOrganisationCode(organisationCode: string) {
        this.organisationCode = organisationCode;
    }
    addNewSurvey(newSurvey: OrganisationSurvey): Observable<boolean> {
        return Observable.create(
            async (observer: Observer<boolean>) => {
                try {
                    let result = await this.adminApi.getAuthenticatedHttpClient()
                    .getInstance()
                    .post(`/api/organisationSurveys/${this.organisationCode}`, newSurvey);
                    if (result.status === 200) {
                        let createdSurvey: OrganisationSurvey = result.data;
                        if (!isNullOrUndefined(createdSurvey) && !isNullOrUndefined((createdSurvey.id)
                              && createdSurvey.id.trim() !==  "")) {
                            if (isNullOrUndefined(this.organisation.organisation_surveys)) {
                                this.organisation.organisation_surveys = [];
                            }
                            this.organisation.organisation_surveys.unshift(createdSurvey);
                            this.dataStore.insertDocument<IOrganisation>(this.organisation, DatabaseKey.organisation)
                                .subscribe(
                                    insertResult => {
                                        observer.next(true);
                                    },
                                    error => {
                                        observer.error(error);
                                        observer.complete();
                                    }
                                );
                        } else {
                            throw ("Adding new survey failed");
                        }
                    }    else {
                        throw ("Adding new survey failed");
                    }
                } catch (error) {
                    observer.error(error);
                    observer.complete();
                }

            }
        );
    }
    private removeDeletedSurvey(deletedSurveyId: string)
    : Observable<Observable<IOrganisation>> {
        if (!isNullOrUndefined(this.organisation) && !isNullOrUndefined(this.organisation.organisation_surveys)) {
            this.organisation.organisation_surveys = this.organisation.organisation_surveys
                .filter(survey => survey.id.toString() !== deletedSurveyId);
            return this.dataStore.insertDocument<IOrganisation>(this.organisation, DatabaseKey.organisation);
        }
    }

}


// WEBPACK FOOTER //
// ./src/utility/admin/OrganisationOperations/OrganisationSurveysOperations/OrganisationSurveysOperations.ts